import { useEffect, useRef } from 'react';
import { SocialResponse } from '../common/interfaces/user';
import { appConfig } from '../../utils/appConfig';
import useTechnicalErrorMessage from '../common/hooks/useTechnicalErrorMessage';
import jwtDecode from 'jwt-decode';

interface SignInGoogleProps {
	googleSignIn: any;
}

declare const google: any;

const SignInGoogle = ({ googleSignIn }: SignInGoogleProps) => {
	const [showTechnicalErrorMessage] = useTechnicalErrorMessage();
	const buttonRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const script = document.createElement('script');
		script.src = 'https://accounts.google.com/gsi/client';
		script.async = true;
		script.onload = () => scriptLoaded();
		document.body.appendChild(script);
	}, []);

	const scriptLoaded = () => {
		if (window.google) {
			google.accounts.id.initialize({
				client_id: appConfig.googleClientId,
				callback: onSuccess
			});
			google.accounts.id.renderButton(buttonRef.current, {
				theme: 'filled_blue',
				size: 'large',
				type: 'standard',
				width: buttonRef?.current?.clientWidth
			});
		}
	};

	const onSuccess = async (response: any) => {
		if (response) {
			const profile: any = jwtDecode(response.credential);
			const googleResponse: SocialResponse = {
				firstName: profile.given_name,
				lastName: profile.family_name,
				email: profile.email,
				token: response.credential,
				type: 'google'
			};
			googleSignIn(googleResponse);
		} else {
			onFailure(response);
		}
	};

	const onFailure = (err: any) => {
		if (err.error !== 'popup_closed_by_user') {
			showTechnicalErrorMessage();
		}
	};

	return (
		<>
			<div className="btn-social" ref={buttonRef}></div>
		</>
	);
};

export default SignInGoogle;
